module.exports = __webpack_public_path__ + "c21dab434fed66911d089b44f99ec4fb.png";